import { createTheme, MantineColorsTuple } from '@mantine/core';

// FixByte IT Cyberorange palette
const cyberOrange: MantineColorsTuple = [
  '#fff4e6',
  '#ffe8cc',
  '#ffd199',
  '#ffb866',
  '#ff9f33',
  '#ff8c1a',
  '#ff6600', // Main brand color
  '#e65c00',
  '#cc5200',
  '#b34700',
];

// Dark gray palette for backgrounds
const darkGray: MantineColorsTuple = [
  '#f5f5f5',
  '#e0e0e0',
  '#bdbdbd',
  '#9e9e9e',
  '#757575',
  '#616161',
  '#424242',
  '#303030',
  '#212121',
  '#121212',
];

// Personenfarbe „Grau" (lib/personColors.ts, `slate`) — gleiche Töne wie Mantine-Grau, eigener Name,
// damit „abgesagt"/„unbekannt" (gray) und die Person auseinanderzuhalten sind; die Person trägt
// zusätzlich überall einen orangen Rand.
const slate: MantineColorsTuple = [
  '#f8f9fa',
  '#f1f3f5',
  '#e9ecef',
  '#dee2e6',
  '#ced4da',
  '#adb5bd',
  '#868e96',
  '#495057',
  '#343a40',
  '#212529',
];

export const theme = createTheme({
  primaryColor: 'cyberOrange',
  colors: {
    cyberOrange,
    darkGray,
    slate,
  },
  fontFamily: '"Outfit", -apple-system, BlinkMacSystemFont, sans-serif',
  fontFamilyMonospace: '"JetBrains Mono", monospace',
  headings: {
    fontFamily: '"Outfit", -apple-system, BlinkMacSystemFont, sans-serif',
    fontWeight: '600',
  },
  defaultRadius: 'md',
  cursorType: 'pointer',
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        root: {
          fontWeight: 500,
          transition: 'all 0.2s ease',
        },
      },
    },
    Card: {
      defaultProps: {
        radius: 'lg',
        withBorder: true,
      },
      styles: {
        root: {
          backgroundColor: 'var(--mantine-color-dark-7)',
          borderColor: 'var(--mantine-color-dark-5)',
        },
      },
    },
    Paper: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        root: {
          backgroundColor: 'var(--mantine-color-dark-7)',
        },
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    PasswordInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    Select: {
      defaultProps: {
        radius: 'md',
      },
    },
    Textarea: {
      defaultProps: {
        radius: 'md',
      },
    },
    Modal: {
      defaultProps: {
        radius: 'lg',
        centered: true,
      },
    },
    Tooltip: {
      defaultProps: {
        // touch: true → am Handy erscheint der Tooltip bei langem Drücken/Antippen,
        // nicht nur beim Maus-Hover. Gilt app-weit für alle Tooltips.
        events: { hover: true, focus: false, touch: true },
        withArrow: true,
        openDelay: 300,
        // Tooltips IMMER zuoberst: Drawer/Modals/Menus im Portal nutzen bis zu 1200
        // (Cockpit 700/750, Menus 1100, Zwilling-Picker 1200, KIAN-Panel) — mit dem
        // Mantine-Default (300) landeten Tooltips daneben teils HINTER diesen Ebenen.
        withinPortal: true,
        zIndex: 1600,
      },
    },
    Stepper: {
      styles: {
        stepIcon: {
          backgroundColor: 'var(--mantine-color-dark-6)',
          borderColor: 'var(--mantine-color-dark-4)',
        },
      },
    },
  },
});

